/**
 * Espera a que `work` termine, pero como máximo `ms`. Nunca rechaza: si `work`
 * falla o tarda más, simplemente deja de esperar (quien la llama decide qué
 * hacer con lo que no llegó).
 */
export function waitAtMost(work: Promise<unknown>, ms: number): Promise<void> {
  return new Promise((resolve) => {
    const timer = setTimeout(resolve, ms);
    const done = () => {
      clearTimeout(timer);
      resolve();
    };
    work.then(done, done);
  });
}
